// src/store/UserStore.ts
import { reactive } from "vue";
import { IStore } from "./index";
/**
 * IUserState
 */
 declare interface User {
  gender: number,
  name: string,
  nickname: string,
  phone: string,
  picture:string,
  role_name:string,
  images:string,
  status:number,
  store_id:number
 }
declare interface UserState {
  user:User|null,
  setUser:Function,
  getUser:Function
}

const storeUser = reactive({
  user: null,
  getUser() { 
    if(this.user?.nickname){
      return this.user
    }else{
      this.setUser(JSON.parse(localStorage.getItem('user_info') as any))
      return this.user
    }
    
  },
  setUser (user:User) {
    this.user = user
  }
} as UserState);
const store: IStore<UserState> = {
  persistedState: false,
  state: storeUser,
};
export default store;
export { storeUser };